import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { companyProfile } from '../content/siteContent';
import { findServiceBySlug } from '../content/servicesData';

function ServiceDetail() {
  const { slug } = useParams();
  const service = findServiceBySlug(slug);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  return (
    <div className="inner-page">
      <Seo
        title={service.seoTitle}
        description={service.seoDescription}
        keywords={service.seoKeywords}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: service.title,
          description: service.seoDescription,
          serviceType: service.menuLabel,
          provider: {
            '@type': 'Organization',
            name: companyProfile.legalName,
            url: companyProfile.websiteUrl
          },
          areaServed: {
            '@type': 'City',
            name: 'Ahmedabad'
          },
          url: `${companyProfile.websiteUrl}/services/${service.slug}`
        }}
      />

      {service.heroImageSrc ? (
        <section className="service-banner">
          <img
            src={service.heroImageSrc}
            alt={service.heroImageAlt || service.title}
            className="service-banner-image"
          />
          <div className="service-banner-badge">
            <span className="service-banner-dot" />
            <h1>{service.shortTitle}</h1>
          </div>
        </section>
      ) : null}

      <section className="page-hero service-hero">
        <div className="service-hero-copy service-hero-copy-standalone">
          <p className="eyebrow">{service.shortTitle}</p>
          <h1>{service.heroTitle}</h1>
          <p>{service.heroDescription}</p>
        </div>
      </section>

      <section className="section">
        <div className="service-page-grid">
          <article className="story-panel">
            <p className="eyebrow">What This Service Covers</p>
            <h2>{service.title}</h2>
            <div className="service-detail-copy">
              {service.detailParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
            <div className="keyword-row">
              {service.seoKeywords.map((keyword) => (
                <span key={keyword} className="keyword-chip">
                  {keyword}
                </span>
              ))}
            </div>
          </article>

          <article className="promise-block single-column">
            <div className="check-list">
              {service.deliverables.map((item) => (
                <div key={item} className="check-item">
                  <span className="check-badge">Key</span>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </article>
        </div>
      </section>

      <section className="section section-light">
        <div className="section-heading">
          <p className="eyebrow">Business Outcomes</p>
          <h2>What this service is designed to improve.</h2>
        </div>

        <div className="feature-grid">
          {service.outcomes.map((item, index) => (
            <article key={item} className="feature-card">
              <span className="feature-code">0{index + 1}</span>
              <h3>{item}</h3>
              <p>
                {service.shortTitle} is planned to create practical business value through clearer
                delivery, stronger user understanding, and more confident digital execution.
              </p>
            </article>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="cta-banner">
          <div>
            <p className="eyebrow">Need This Service</p>
            <h2>{service.shortTitle} inquiries can start right here.</h2>
          </div>
          <Link to="/contact" className="button-primary">
            {service.ctaLabel}
          </Link>
        </div>
      </section>
    </div>
  );
}

export default ServiceDetail;
